import { bl_fi_internal_sales_return_import_file_helper_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class SalesReturnFileImportHelperContainerModel extends BaseContainerModel {
    bl_fi_internal_sales_return_import_file_helper: bl_fi_internal_sales_return_import_file_helper_RowClass = new bl_fi_internal_sales_return_import_file_helper_RowClass();
}